import { makeRequest } from '~shared/api/make-request';

import type { DocumentApi } from './document-api';

interface ConstructorParams {
  host: string;
}

export class GatewayDocumentApi implements DocumentApi {
  private host: string;

  constructor(params: ConstructorParams) {
    this.host = params.host;
  }

  generate(applicationId: string): Promise<Blob> {
    return makeRequest<Blob>({
      httpMethod: 'POST',
      responseType: 'blob',
      type: 'json',
      url: `${this.host}/merchant-portal/api/v1/documents/public/generate`,
      timeout: 60 * 2 * 1000,
      withCredentials: true,
      payload: { type: 'LOAN_NOTIFICATION', applicationId },
    });
  }
}
